import { Login } from './pages/login';

export const routesunlogged = [
  {
    path: '*',
    element: <Login />
  },
];
